import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule,ReactiveFormsModule }from'@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { AppointmentCalendarComponent } from './appointment-calendar/appointment-calendar.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';

const routes: Routes = [
  {
    path: '', component:AppComponent,
    children: [
      
    ]
  },
  {
    path: 'online-appointment/:org', component:AppointmentCalendarComponent,
  },
  {
    path: 'confirmation', component:ConfirmationComponent,
  }
  
  
];

@NgModule({
  declarations: [
    AppComponent,
    AppointmentCalendarComponent,
    ConfirmationComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
    }),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  exports: [RouterModule],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
